module.exports = __webpack_public_path__ + "static/images/cover_C10.a3c9039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C10.png
// module id = lT7O
// module chunks = 8